import { Field, FieldProps } from 'formik'
import React from 'react'
import { ButtonGroup, Paragraph } from '@pandiafi/design-system'
import { useTranslation } from 'react-i18next'

import FormFieldWrapper from 'components/FormField'
import { FormValues } from 'views/TerminateContract/TerminateForm/initialValues'
import {
  ShowingSuggestion,
  useShowingSuggestions,
} from 'views/TerminateContract/hooks/useShowingSuggestions'

export const DisplaysSelfField = () => {
  const [t] = useTranslation(['terminateContract'])
  const { showingSuggestions } = useShowingSuggestions()

  return (
    <Field name="displaysSelf">
      {({ field, meta, form }: FieldProps<FormValues['displaysSelf']>) => (
        <FormFieldWrapper
          name={field.name}
          label={t('terminateContract:labels.showing')}
          className="min-tablet:flex-1"
          meta={meta}
          labelBold
          required
        >
          <ButtonGroup
            suggestions={showingSuggestions}
            onChange={(value) => {
              form.setFieldValue(
                field.name,
                value === ShowingSuggestion.TENANT_SHOWS
              )
              form.setFieldValue(
                'masterKeyAccessAllowed',
                value !== ShowingSuggestion.TENANT_SHOWS
              )
            }}
            value={
              meta.value
                ? ShowingSuggestion.TENANT_SHOWS
                : ShowingSuggestion.PROPERTY_COMPANY_GROUP_SHOWS
            }
            sameSize
            fullwidth
          />
          <Paragraph large className="mt-4">
            {t('terminateContract:texts.showingInstructions')}
          </Paragraph>
          <Paragraph large className="mt-2">
            {t('terminateContract:texts.showingInstructions2')}
          </Paragraph>
        </FormFieldWrapper>
      )}
    </Field>
  )
}
